import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CartAlertForm from 'molecules/Alert/Presentation/Alert/AlertForm';
import CartAlertFormInsideModel from 'molecules/Alert/Container/AlertFormInsideModel';
import { UserOrderContext } from '../../../context/context';
import { CART_CLEAR_CONSTANTS } from '../Constants/ClearCartConstant';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import Cart_Error from 'styles/staticAssets/images/Cart_Error.svg';
import { isEmptyEvery } from 'common/utilities/utils';
import {
  removeAllItemAction,
  setUserLastActiveTime,
  removeAllCouponAction,
} from '@kfc-global/react-shared/redux/Actions/CartAction';

export const clearMsgFn = (props, CLEAR_ALL_MSG, TO_CHANGE_LANGUAGE) => {
  return props.langSelector ? (CLEAR_ALL_MSG.MSGTXT3 = TO_CHANGE_LANGUAGE) : CLEAR_ALL_MSG.MSGTXT3;
};

export const ClearCartModule = props => {
  const cartReducer = useSelector(data => data.cartReducer);
  const { cartData = {} } = cartReducer || {};
  const tenantReducer = useSelector(data => data.tenantReducer);
  const { tenantId = '' } = tenantReducer || {};
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const { modalToOpenOnConfirm, modalOpenFrom, confirmCallBack } = userOrderState;
  const dispatch = useDispatch();
  const { CLEAR_ALL_MSG, CLEAR_ALL, CANCEL, TO_CHANGE_LANGUAGE } = CART_CLEAR_CONSTANTS;
  clearMsgFn(props, CLEAR_ALL_MSG, TO_CHANGE_LANGUAGE);
  const {
    SHOW_CLEAR_CART_ALERT,
    DISPOSITION_DATA,
    SEARCH_ORDER_DATA,
    SCHEDULE_ORDER_DATA,
    clearCartChangeFlag,
    orderTypeAlertTitle,
    searchStoreAlertTitle,
  } = START_ORDER_CONSTANTS;
  const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem('dispositionNew'))
    : userOrderState.dispositionNew;

  const onConfirmHandler = () => {
    if (cartData.discountLines.length > 0) {
      let discountLinesId = cartData.discountLines.map(discItem => discItem.id);
      dispatch(
        removeAllCouponAction(
          {
            params: {
              basketId: cartData.id,
            },
            tenantId: tenantId,
            shouldClearCart: true,
          },
          discountLinesId,
        ),
      );
    } else {
      dispatch(
        removeAllItemAction({
          basketId: cartData.id,
          tenantId: tenantId,
        }),
      );
    }
    dispatch(setUserLastActiveTime(new Date()));
    userOrderStateDispatch({
      type: SHOW_CLEAR_CART_ALERT,
      value: { showCartClearAlert: false },
    });
    confirmCallBack && confirmCallBack();
    if (modalToOpenOnConfirm === orderTypeAlertTitle) {
      userOrderStateDispatch({
        type: DISPOSITION_DATA,
        value: { showDisposition: true },
      });
    } else if (modalToOpenOnConfirm === searchStoreAlertTitle) {
      userOrderStateDispatch({
        type: SEARCH_ORDER_DATA,
        value: { showSearchStore: true },
      });
    }
  };
  const onCancelHandler = () => {
    userOrderStateDispatch({
      type: SHOW_CLEAR_CART_ALERT,
      value: { showCartClearAlert: false },
    });
    if (modalOpenFrom === clearCartChangeFlag) {
      userOrderStateDispatch({
        type: SCHEDULE_ORDER_DATA,
        value: {
          showScheduleOrderCatering: true,
          selectedStoreInfo: dispositionNew.store,
          changeFlow: true,
        },
      });
    } else {
      //DO NOTHING
    }
  };
  return (
    <CartAlertFormInsideModel
      handleClose={onCancelHandler}
      classNames='clear-cart-modal'
      CartAlertForm={
        <CartAlertForm
          splitTitle={CLEAR_ALL_MSG}
          imageSrc={Cart_Error}
          altText={'cart-error'}
          confirmButtonText={translateWithI18Next(CLEAR_ALL)}
          cancelButtonText={translateWithI18Next(CANCEL)}
          cancelHandler={onCancelHandler}
          confirmHandler={onConfirmHandler}
        />
      }
    />
  );
};
